// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1w8bd","inner":"Footer_inner__28w2b","nextIcon":"Footer_nextIcon__vO-uR","innerLeft":"Footer_innerLeft__1qRm6"};